import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useEliminaHorario } from './hooks/useEliminaHorario';

const EliminaHorario = ({ datosHorario, ocultaDialogElimina }) => {

    const {nombre, sigla, cargaDetHorario, lstDetHorario, horaInicioTemplate, horaFinalTemplate, handleEliminaHorario, procesa} = useEliminaHorario(datosHorario, ocultaDialogElimina)

    return (
        <div className="card">
            <h5>Elimina Horario</h5>
            <p>
                <strong>Sigla:</strong> {sigla}
            </p>
            <p>
                <strong>Nombre:</strong> {nombre}
            </p>
            <DataTable loading={cargaDetHorario} loadingIcon="pi pi-spin pi-spinner" value={lstDetHorario} tableStyle={{ width: '100%' }}>
                <Column header="Hora Inicio" body={horaInicioTemplate} style={{ width: '50%' }} />
                <Column header="Hora Final" body={horaFinalTemplate} style={{ width: '50%' }} />
            </DataTable>
            <br />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <Button label="Cancelar" onClick={ocultaDialogElimina} disabled={cargaDetHorario || procesa}/>
                </div>
                <div className="field col-12 md:col-6">
                    <Button label="Eliminar" className="p-button-danger" onClick={handleEliminaHorario} loading={procesa} disabled={cargaDetHorario} />
                </div>
            </div>
        </div>
    );
};

export default EliminaHorario;
